import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import PropType from "prop-types";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { addQtyItem, minusQtyItem } from "../../redux/actions/basketActions";

const BasketItemControl = ({ product }) => {
  const dispatch = useDispatch();

  const hasColors = useMemo(() => {
    return product?.availableColors?.length > 0;
  }, [product])

  const hasSizes = useMemo(() => {
    return !product?.sizes?.includes('Free Size');
  }, [product])

  const complete = useMemo(() => {

    if (hasColors && !product.selectedColor) {
      return false;
    }
    if (hasSizes && !product.selectedSize) {
      return false;
    }
    return true;

  }, [product, product.selectedColor, product.selectedSize])

  const numInStock = useMemo(() => {
    if (hasSizes && hasColors && product.selectedColor && product.selectedSize) {
      const colorName = product.availableColors.filter(color => color.hex === product.selectedColor)[0].name;
      let stock = product.stock[product.selectedSize][colorName];
      return stock;
    }
    if (hasColors && product.selectedColor) {
      const colorName = product.availableColors.filter(color => color.hex === product.selectedColor)[0].name;
      let stock = product.stock['Free Size'][colorName];
      return stock;
    }
    if (!hasColors && !hasSizes) {
      let stock = product.stock['Free Size']['Free Color'];
      return stock;
    }

    return undefined;
  }, [product.selectedColor, product.selectedSize, complete])



  const onAddQty = () => {
    if (product.quantity < numInStock) {
      dispatch(addQtyItem(product.id));
    }
  };

  const onMinusQty = () => {
    if (numInStock >= product.quantity && product.quantity !== 0) {
      dispatch(minusQtyItem(product.id));
    }
  };

  return (
    <div className="basket-item-control">
      <button
        className="button button-border button-border-gray button-small basket-control basket-control-add"
        disabled={numInStock === product.quantity}
        onClick={onAddQty}
        type="button"
      >
        <PlusOutlined style={{ fontSize: "9px" }} />
      </button>
      <button
        className="button button-border button-border-gray button-small basket-control basket-control-minus"
        disabled={product.quantity === 1}
        onClick={onMinusQty}
        type="button"
      >
        <MinusOutlined style={{ fontSize: "9px" }} />
      </button>
    </div>
  );
};

BasketItemControl.propTypes = {
  product: PropType.shape({
    id: PropType.string,
    name: PropType.string,
    brand: PropType.string,
    price: PropType.number,
    quantity: PropType.number,
    maxQuantity: PropType.number,
    description: PropType.string,
    keywords: PropType.arrayOf(PropType.string),
    selectedSize: PropType.string,
    selectedColor: PropType.string,
    imageCollection: PropType.arrayOf(PropType.string),
    sizes: PropType.arrayOf(PropType.number),
    image: PropType.string,
    imageUrl: PropType.string,
    isFeatured: PropType.bool,
    isRecommended: PropType.bool,
    availableColors: PropType.arrayOf(PropType.string),
  }).isRequired,
};

export default BasketItemControl;
